
import { Component } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
    selector: 'ups-toggle',
    // templateUrl: './toggle-button.component.html',
    // <ngl-checkbox-toggle [label]="customCheckbox" [error]="hasError ? error : null">
    //     <input ngl type="checkbox" [required]="required" [disabled]="disabled">
    //     </ngl-checkbox-toggle>
    template: `<div>
    <ngl-checkbox-toggle [label]="to.label || ''" [ngClass]="to['customClass']" (change)="change(field)">
      <input
        ngl
        type="checkbox"
        [formControl]="$any(formControl)"
        [required]="to.required || false"
        [placeholder]="to.placeholder"
      />
    </ngl-checkbox-toggle>
  </div>`,
    styleUrls: ['./toggle.type.component.scss'],
    standalone: false
})

export class ToggleTypeComponent extends FieldType {

  public change(field?: FormlyFieldConfig): void {
    if (field?.templateOptions && field.templateOptions['onChange']) {
      const value = this.model[this.key.toString()];
      field.templateOptions['onChange'](this, value, this.model);
    }
  }

}